// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"633":"f21872f3","720":"eb258fb2","787":"ef2639f2"}[chunkId] + ".chunk.js";
};